import Reflux from 'reflux';
import { QuizActions } from 'actions';
import SteelCompass from 'services/SteelCompass';

function dateCheck(from, to, check) {
  let fDate, lDate, cDate;
  fDate = Date.parse(from);
  lDate = Date.parse(to);
  cDate = Date.parse(check);

  if (cDate <= lDate && cDate >= fDate) {
    return true;
  }
  return false;
}

const QuizStore = Reflux.createStore({
  listenables: [QuizActions],
  data: {
    started: false,
    ended: false,
    time: '',
    userdata: {},
    results: {},
    pageId: null,
    content: [],
    answers: [],
    score: null,
    threshold: null,
    steps: [
      'QUIZ_INTRO',
      'QUIZ_MAIN',
      'QUIZ_FAIL',
      'QUIZ_SUCCESS',
      'QUIZ_RESULT'
    ],
    currentStep: 'QUIZ_INTRO',
    currentQuestion: 0,
    displayNext: null,
    displayPrev: null,
    testComplete: false,
    startTime: null
  },
  getInitialState() {
    return this.data;
  },
  initialize(data, settings, pageId, userdata) {
    let can = true;
    // if (
    //   (settings.hasOwnProperty('endDate') && settings.endDate === '') ||
    //   !settings.hasOwnProperty('endDate')
    // ) {
    //   can = false;
    // }
    // if (
    //   (settings.hasOwnProperty('startDate') && settings.startDate !== '') ||
    //   !settings.hasOwnProperty('startDate')
    // ) {
    //   can = false;
    // }
    // if (!!settings.startDate && !!settings.endDate) {
    //   if (!dateCheck(settings.startDate, settings.endDate, new Date())) {
    //     can = false;
    //   }
    // } else if (
    //   !settings.startDate &&
    //   !!settings.endDate &&
    //   !(new Date() <= new Date(settings.endDate))
    // ) {
    //   can = false;
    // } else if (
    //   !!settings.startDate &&
    //   !settings.endDate &&
    //   !(new Date() >= new Date(settings.startDate))
    // ) {
    //   can = false;
    // }
    can && !this.data.started && this.startTimer(settings);
    this.data = {
      ...this.data,
      started: false,
      userdata: !!userdata ? userdata : { locked: false, pages: {} },
      results: {},
      pageId: pageId,
      content: this.normalizeData(data),
      answers: [],
      score: null,
      threshold: settings.threshold / 100,
      currentStep: 'QUIZ_INTRO',
      currentQuestion: 0,
      displayNext: this.data.content.length - 1 > this.data.currentQuestion,
      displayPrev: this.data.currentQuestion >= 1,
      testComplete: false,
      startTime: null
    };
    this.trigger(this.data);
  },
  getTimeRemaining(endtime) {
    var t = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
      total: t,
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  },
  startTimer(settings) {
    const updateClock = () => {
      const t = this.getTimeRemaining(settings.endDate);
      if (t.total <= 0) {
        this.calculateTest();
        clearInterval(timeinterval);
      }
      this.data.time = `${t.hours}h ${t.minutes}m ${t.seconds}s left`;
      this.trigger(this.data);
    };
    updateClock(); // run function once at first to avoid delay
    const timeinterval = setInterval(updateClock, 1000);
  },
  reset() {
    this.data = {
      started: false,
      userdata: {},
      results: {},
      pageId: null,
      content: [],
      answers: [],
      score: null,
      threshold: null,
      currentStep: 'QUIZ_INTRO',
      steps: [
        'QUIZ_INTRO',
        'QUIZ_MAIN',
        'QUIZ_FAIL',
        'QUIZ_SUCCESS',
        'QUIZ_RESULT'
      ],
      currentQuestion: 0,
      displayNext: null,
      displayPrev: null,
      testComplete: false,
      startTime: null
    };
    this.trigger(this.data);
  },
  normalizeData(data) {
    return data.map(({ pageModules }) => {
      const {
        id,
        data: {
          params: { task, taskResults }
        }
      } = pageModules[0];
      this.data.results[id] =
        (taskResults && taskResults[taskResults.length - 1]) || {};
      return { ...task, pageModuleId: id, taskResults };
    });
  },
  calculateTest() {
    for (let i = 0; i < this.data.content.length; i++) {
      if (!this.data.content[i].hasOwnProperty('answered')) {
        return alert('You have not answered all questions to end quiz');
      }
    }
    SteelCompass.request(
      'quiz',
      'complete',
      {
        pageId: this.data.pageId
      },
      0,
      1000
    ).then(({ score, answers }) => {
      this.data.score = score;
      this.data.answers = answers;
      if (score >= this.data.content.length * (this.data.threshold || 0.8)) {
        this.data.currentStep = 'QUIZ_SUCCESS';
      } else {
        this.data.currentStep = 'QUIZ_FAIL';
      }
      const endTime = new Date();
      const duration = endTime - this.data.startTime;
      this.data.ended = true;
      this.trigger(this.data);
      const page = this.data.userdata.pages[this.data.pageId]
        ? this.data.userdata.pages[this.data.pageId]
        : [];
      const data = {
        ...this.data.userdata,
        locked: true,
        pages: {
          ...this.data.userdata.pages,
          [this.data.pageId]: [
            ...page,
            {
              score: score,
              total: this.data.content.length,
              status: this.data.currentStep,
              startTime: this.data.startTime,
              endTime: new Date(),
              duration
            }
          ]
        }
      };
      this.data.userdata = data;
      this.trigger(data);
      return SteelCompass.request('content', 'saveDataForObject', {
        objectId: this.data.pageId,
        objectType: 'page',
        data
      });
    });
  },
  updateAnswer(taskId, pageModuleId, taskResult, bodyFiles) {
    let numAnswers = 0;
    this.data.content = this.data.content.map(q => {
      if (q.taskResults.length) {
        numAnswers++;
      }
      if (q.pageModuleId === pageModuleId) {
        return {
          ...q,
          answered: taskResult.body.value,
          taskResults: [
            ...q.taskResults,
            {
              id: taskResult.id,
              feedback: taskResult.feedback || {},
              visible: taskResult.visible,
              bodyFiles,
              body: {
                value: taskResult.body.value
              }
            }
          ]
        };
      }
      return q;
    });
    if (numAnswers === this.data.content.length) {
      this.data.testComplete = true;
    }
    // localStorage.setItem(this.data.pageId, JSON.stringify(this.data.content));
    this.trigger(this.data);
  },
  setNextStep(step) {
    if (typeof step === 'string') {
      const index = this.data.steps.findIndex(i => i === step);
      this.data.currentStep = this.data.steps[index];
    } else {
      const index = this.data.steps.findIndex(i => i === this.data.currentStep);
      this.data.currentStep = this.data.steps[index + 1];
    }
    if (this.data.currentStep === 'QUIZ_MAIN') {
      this.data.startTime = new Date();
      this.data.started = true;
    }
    this.trigger(this.data);
  },
  next() {
    this.data.currentQuestion = this.data.currentQuestion + 1;
    this.data.displayNext =
      this.data.content.length - 1 > this.data.currentQuestion;
    this.data.displayPrev = this.data.currentQuestion >= 1;
    this.trigger(this.data);
  },
  prev() {
    this.data.currentQuestion = this.data.currentQuestion - 1;
    this.data.displayNext =
      this.data.content.length - 1 > this.data.currentQuestion;
    this.data.displayPrev = this.data.currentQuestion >= 1;
    this.trigger(this.data);
  },
  setQuestion(index) {
    this.data.currentQuestion = index;
    this.data.displayNext =
      this.data.content.length - 1 > this.data.currentQuestion;
    this.data.displayPrev = this.data.currentQuestion >= 1;
    this.trigger(this.data);
  }
});

export default QuizStore;



// WEBPACK FOOTER //
// ./src/js/stores/Quiz.js